import { useMemo } from "react";

import CardType from "@app/enum/dashboard/CardType";
import getCardByType from "@app/scene/dashboard/utils/getCardByType";

const useCard = (type: CardType) => useMemo(() => getCardByType(type)!, [type]);

export default useCard;
